<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii">
<h1 class="toc-title">CONTENTS</h1>
</a><h2 class="toc1"><a id="page_vii"></a><a href="#/xhtml/04_Chapter01">Arthur Christmas</a></h2>
<h2 class="toc1"><a href="#/xhtml/05_Chapter02">Bad Santa</a></h2>
<h2 class="toc1"><a href="#/xhtml/06_Chapter03">Batman Returns</a></h2>
<h2 class="toc1"><a href="#/xhtml/07_Chapter04">Bridget Jones’s Diary</a></h2>
<h2 class="toc1"><a href="#/xhtml/08_Chapter05">Christmas Animations</a></h2>
<h2 class="toc1"><span href="#/xhtml/09_Chapter06" title="Link target outside of Sample">Deck the Halls</span></h2>
<h2 class="toc1"><span href="#/xhtml/10_Chapter07" title="Link target outside of Sample">Die Hard</span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter08" title="Link target outside of Sample">Doctor Who Christmas Specials</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_Chapter09" title="Link target outside of Sample">Edward Scissorhands</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_Chapter10" title="Link target outside of Sample">Elf</span></h2>
<h2 class="toc1"><span href="#/xhtml/14_Chapter11" title="Link target outside of Sample">Frozen</span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Chapter12" title="Link target outside of Sample">Gremlins</span></h2>
<h2 class="toc1"><span href="#/xhtml/16_Chapter13" title="Link target outside of Sample">The Grinch</span></h2>
<h2 class="toc1"><span href="#/xhtml/17_Chapter14" title="Link target outside of Sample">Harry Potter</span></h2>
<h2 class="toc1"><span href="#/xhtml/18_Chapter15" title="Link target outside of Sample">The Holiday</span></h2>
<h2 class="toc1"><span href="#/xhtml/19_Chapter16" title="Link target outside of Sample">Home Alone</span></h2>
<h2 class="toc1"><span href="#/xhtml/20_Chapter17" title="Link target outside of Sample">It’s a Wonderful Life</span></h2>
<h2 class="toc1"><span href="#/xhtml/21_Chapter18" title="Link target outside of Sample">Jack Frost</span></h2>
<h2 class="toc1"><span href="#/xhtml/22_Chapter19" title="Link target outside of Sample">James Bond</span></h2>
<h2 class="toc1"><span href="#/xhtml/23_Chapter20" title="Link target outside of Sample">Jingle All the Way</span></h2>
<h2 class="toc1"><span href="#/xhtml/24_Chapter21" title="Link target outside of Sample">Klaus</span></h2>
<a id="page_viii">
</a><h2 class="toc1"><a id="page_viii"></a><span href="#/xhtml/25_Chapter22" title="Link target outside of Sample">Krampus</span></h2>
<h2 class="toc1"><span href="#/xhtml/26_Chapter23" title="Link target outside of Sample">Last Christmas</span></h2>
<h2 class="toc1"><span href="#/xhtml/27_Chapter24" title="Link target outside of Sample">Love Actually</span></h2>
<h2 class="toc1"><span href="#/xhtml/28_Chapter25" title="Link target outside of Sample">Miracle on 34th Street</span></h2>
<h2 class="toc1"><span href="#/xhtml/29_Chapter26" title="Link target outside of Sample">The Muppet Christmas Carol</span></h2>
<h2 class="toc1"><span href="#/xhtml/30_Chapter27" title="Link target outside of Sample">National Lampoon’s Christmas Vacation</span></h2>
<h2 class="toc1"><span href="#/xhtml/31_Chapter28" title="Link target outside of Sample">The Nightmare Before Christmas</span></h2>
<h2 class="toc1"><span href="#/xhtml/32_Chapter29" title="Link target outside of Sample">The Polar Express</span></h2>
<h2 class="toc1"><span href="#/xhtml/33_Chapter30" title="Link target outside of Sample">The Princess Switch</span></h2>
<h2 class="toc1"><span href="#/xhtml/34_Chapter31" title="Link target outside of Sample">The Santa Clause</span></h2>
<h2 class="toc1"><span href="#/xhtml/35_Chapter32" title="Link target outside of Sample">Scrooged</span></h2>
<h2 class="toc1"><span href="#/xhtml/36_Chapter33" title="Link target outside of Sample">Shaun the Sheep: The Flight Before Christmas</span></h2>
<h2 class="toc1"><span href="#/xhtml/37_Chapter34" title="Link target outside of Sample">Shrek</span></h2>
<h2 class="toc1"><span href="#/xhtml/38_Chapter35" title="Link target outside of Sample">The Snowman</span></h2>
<h2 class="toc1"><span href="#/xhtml/39_Chapter36" title="Link target outside of Sample">Star Wars Movies</span></h2>
<h2 class="toc1"><span href="#/xhtml/40_Chapter37" title="Link target outside of Sample">Star Wars Holiday Special</span></h2>
<h2 class="toc1"><span href="#/xhtml/41_Chapter38" title="Link target outside of Sample">Trading Places</span></h2>
<h2 class="toc1"><span href="#/xhtml/42_Chapter39" title="Link target outside of Sample">While You Were Sleeping</span></h2>
<h2 class="toc1"><span href="#/xhtml/43_Chapter40" title="Link target outside of Sample">White Christmas</span></h2>
<h2 class="toc1"><span href="#/xhtml/44_Chapter41" title="Link target outside of Sample">Answers</span></h2>
<h2 class="toc"><span href="#/xhtml/45_About_the_Author" title="Link target outside of Sample">About the Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3850f8a4